import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import BleService from '../services/ble/BleService';
import { updateDeviceConnectionStatus } from '../state/ducks/ble/bleService';

export const useDeviceConnectionStatus = (deviceId) => {
    const dispatch = useDispatch();

    const onConnectionStatusChanged = (event) => {
        const { connectionStatus } = event.data;
        dispatch(updateDeviceConnectionStatus(deviceId, connectionStatus));
    }

    useEffect(() => {
        const bleService = new BleService();
        const deviceClient = bleService.getDevice(deviceId);

        deviceClient.subscribeOnConnectionStatusChanged(onConnectionStatusChanged);

        return () => {
            deviceClient.unsubscribeOnConnectionStatusChanged(onConnectionStatusChanged);
        }
    }, [deviceId, dispatch]);
}